<div [class.next]="next" [class.previous]="previous" class="chapter-switcher">
    @if (chapter) {
        <button (click)="turnToPage()">
            @if (previous) {
                <span [class.triangle-left]="previous"></span>
            }
            <span class="chapter-switch-text">
        @if (showChapterNames && hierarchy) {
            <span class="block heading">Kapitel {{ hierarchy.join('.') }}</span>
        }
                @if (!showChapterNames) {
                    <span class="block heading">{{ chapter.orderName | uppercase }}</span>
                }
                <span class="block">{{ nameToShow }}</span>
      </span>
            @if (next) {
                <span [class.triangle-right]="next"></span>
            }
        </button>
    }
</div>
